import { generateIntroCallMessage } from '../blurbs';

import type { IUseIntroCallProps, IIntroCallValues } from '../types';

export const useIntroCall = ({
  closeModal,
  handleSubmit,
  whichPerson,
  otherPerson,
}: IUseIntroCallProps) => {
  const initialValues: IIntroCallValues = {
    patientDevices: [],
    didReceiveSetUpCall: null,
    reviewRPMProgramGoal: [],
    reviewRPMProgramGoal2: [],
    reviewCareTeam: [],
    remoteDevices: [],
    careTeamContactInformation: [],
    whichPerson,
    otherPerson,
  };

  const preparedData = (data: IIntroCallValues) => {
    const formData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== null),
    );
    return {
      patientDevices: formData.patientDevices,
      didReceiveSetUpCall: formData.didReceiveSetUpCall,
      reviewRPMProgramGoal: formData.reviewRPMProgramGoal,
      reviewRPMProgramGoal2: formData.reviewRPMProgramGoal2,
      reviewCareTeam: formData.reviewCareTeam,
      remoteDevices: formData.remoteDevices,
      careTeamContactInformation: formData.careTeamContactInformation,
      whichPerson: formData.whichPerson,
      otherPerson: formData.otherPerson,
    };
  };

  const onSaveForm = (formData: IIntroCallValues) => {
    const preparedValues = preparedData(formData);

    const filteredValues = Object.fromEntries(
      Object.entries(preparedValues).filter(([_, value]) => value !== null),
    ) as IIntroCallValues;
    const message = generateIntroCallMessage(filteredValues);

    handleSubmit(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
